import React, { useState } from 'react';
import { Reveal } from '../common/Reveal';
import { Lightbox } from '../common/Lightbox';
import { PROJECTS } from '../../data/constants';

export function Projects() {
  const [selected, setSelected] = useState(null);

  return (
    <section id="projects" className="py-20 md:py-28 px-8 md:px-16 bg-nestlent-off-white">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <Reveal>
            <div className="text-[0.68rem] font-normal tracking-[0.35em] uppercase text-nestlent-green mb-3">Portfolio</div>
          </Reveal>
          <Reveal delay={120}>
            <h2 className="font-serif text-[clamp(2.2rem,4vw,3.4rem)] font-light leading-[1.12] text-nestlent-charcoal mb-5">
              Featured <em className="font-serif italic text-nestlent-green">Projects</em>
            </h2>
          </Reveal>
          <Reveal delay={180}>
            <div className="w-16 h-px bg-nestlent-green mx-auto mb-8" />
          </Reveal>
        </div>

        {/* Gallery Grid — 4 images */}
        <Reveal delay={100}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {PROJECTS.map((p, i) => (
              <div
                key={i}
                className="group relative overflow-hidden rounded-sm cursor-pointer h-[380px]"
                onClick={() => setSelected(p.img)}
              >
                {/* Image */}
                <img
                  src={p.img}
                  alt={p.title}
                  className="absolute inset-0 w-full h-full object-cover transition-all duration-700 group-hover:scale-[1.06]"
                />
                {/* Permanent dark gradient at bottom */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />

                {/* Hover overlay */}
                <div className="absolute inset-0 bg-black/0 transition-all duration-400 group-hover:bg-black/20" />

                {/* Arrow */}
                <div className="absolute top-4 right-4 w-9 h-9 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white opacity-0 -translate-y-2 transition-all duration-300 group-hover:opacity-100 group-hover:translate-y-0 z-[2]">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M7 17L17 7M17 7H7M17 7v10"/></svg>
                </div>

                {/* Info — title and location */}
                <div className="absolute bottom-0 left-0 right-0 px-6 pb-5 z-[1]">
                  <div className="font-serif text-[1.15rem] font-normal text-white leading-tight">{p.title}</div>
                  <div className="text-[0.75rem] text-white/60 mt-1">{p.loc}</div>
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
      {selected && <Lightbox src={selected} onClose={() => setSelected(null)} />}
    </section>
  );
}
